import { createContext } from 'react';
import { ChangeDialog } from './interfaces';

export const DialogContext = createContext<ChangeDialog | undefined>(undefined);
